import { useQuery } from "@tanstack/react-query";
import { getAll } from "../../../services/entity";
import { allEntitiesQueryKey } from "./queryKeys";

// Fetches the catalog of entities available for selection. TanStack dedupes by
// key so the request runs once per cache window regardless of how many
// subqueries the user opens.
export function useAllEntitiesQuery() {
  return useQuery({
    queryKey: allEntitiesQueryKey(),
    queryFn: getAll,
    refetchOnWindowFocus: false,
    retry: 1,
  });
}
